<template>
	<div class="nav">
		<el-menu
		  	:default-active="activeIndex2"
		  	class="el-menu-demo"
		  	mode="horizontal"
		  	@select="handleSelect"
		  	background-color="#545c64"
		  	text-color="#fff"
		  	active-text-color="#ffd04b">
		  	<el-menu-item v-for="item in navData" @click="selItem(item.href)" :index="item.id">{{item.name}}</el-menu-item>
		</el-menu>
	</div>
</template>
<script>
import Index from '../pages/Index/Index'
import About from '../pages/About/About'
import ContactUs from '../pages/ContactUs/ContactUs'
import NewCenter from '../pages/NewCenter/NewCenter'
import ProductCenter from '../pages/ProductCenter/ProductCenter'
import ProjectCase from '../pages/ProjectCase/ProjectCase'
import ServiceCenter from '../pages/ServiceCenter/ServiceCenter'
import Solution from '../pages/Solution/Solution'
export default {
	name: '',
	components: {},
	data() {
		return {
			msg: '我是导航部分',
			navData:[],
		}
	},
  	methods: {
	    selItem(item) {
	    	console.log(item);
			this.$router.push(item);
	    },
	    getData() {
			this.axios({
				method: 'get',
				url: this.GLOBAL.navListApi,
				data: {}
			})
			.then((res) => {
				this.navData = res.data.data;
			})
			.catch((err) => {
				console.log(err)
			})
	    },
  	},
  	created() {
    	this.getData();
  	}
}

</script>
<style lang="less" scoped="scoped">
@import url("../../styles/main.less");
.nav {
	.el-menu--horizontal>.el-menu-item{
		width:calc(100%/4);
		text-align:center;
		.height(80);
		.line-height(80);
	}
}

</style>



// WEBPACK FOOTER //
// src/components/common/Nav.vue